import {
  addDays,
  addHours,
  addMinutes,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from 'date-fns'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

interface UseTimerProps {
  endDate?: string
}

const useTimer = ({ endDate }: UseTimerProps) => {
  const t = useTranslations()

  let currentDate = new Date()
  const endTournamentDate = endDate ? new Date(endDate) : new Date()

  const daysLeft = differenceInDays(endTournamentDate, currentDate)
  currentDate = addDays(currentDate, daysLeft)
  const hoursLeft = differenceInHours(endTournamentDate, currentDate)
  currentDate = addHours(currentDate, hoursLeft)
  const minutesLeft = differenceInMinutes(endTournamentDate, currentDate)
  currentDate = addMinutes(currentDate, minutesLeft)
  const secondsLeft = differenceInSeconds(endTournamentDate, currentDate)

  const [hasInfoAboutTournament, setInfoAboutTournament] = useState(!!endDate)

  const [time, setTime] = useState<{
    days: number
    hours: number
    minutes: number
    seconds: number
  }>({
    days: daysLeft,
    hours: hoursLeft,
    minutes: minutesLeft,
    seconds: secondsLeft,
  })

  useEffect(() => {
    if (hasInfoAboutTournament !== Boolean(endDate))
      setInfoAboutTournament(!!endDate)
  }, [endDate, hasInfoAboutTournament])

  useEffect(() => {
    const timer = setTimeout(() => {
      setTime({
        days: daysLeft,
        hours: hoursLeft,
        minutes: minutesLeft,
        seconds: secondsLeft,
      })
    }, 1000)

    return () => clearTimeout(timer)
  })

  if (!endTournamentDate)
    return {
      t,
      time: { days: 0, hours: 0, minutes: 0, seconds: 0 },
      hasInfoAboutTournament,
    }

  return { t, time, hasInfoAboutTournament }
}

export default useTimer
